import React from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Modal, Message, Input } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import '../Merchandise/style.css'
import {
  getExpWarning,
  getStockWarning,
  getMainDetail,
  getBatchDetail,
  destroyRecord,
} from '../../../api/businessCommodity'
import MultiTable from '../components/multiTable'
import { toNormalTime, fixPhotoUrl } from '../../../util/index'

class Statement extends React.Component {
  state = {
    dataSource: [],
    batchList: [],
    visible: false,
    mainList: [],
    isAsking: false,
    askingData: {},
    description: '',
  }

  componentDidMount() {
    if (window.location.pathname == '/home/purchaseSalesInventory/ExpWarning') {
      this.getExpWarningList()
    }

    if (
      window.location.pathname == '/home/purchaseSalesInventory/StockWarning'
    ) {
      this.getStockWarningList()
    }
  }

  // 获取临期商品列表
  getExpWarningList = async () => {
    const club_id = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getExpWarning(club_id)
    if (status == 1) {
      this.setState({ dataSource: data })
    } else {
      Message.error(detail)
    }
  }

  // 获取库存警告列表
  getStockWarningList = async () => {
    const club_id = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getStockWarning(club_id)
    if (status == 1) {
      this.setState({ dataSource: data })
    } else {
      Message.error(detail)
    }
  }

  // 点击行打开模态窗
  openModal = async (record) => {
    this.setState({ visible: true })
    const { data, status, detail } = await getMainDetail(record.id)
    if (status == 1) {
      this.setState({ mainList: data })
    } else {
      Message.error(detail)
    }
  }

  // 模态窗确定
  onOk = () => {
    this.setState({ visible: false })
  }

  // 模态窗关闭
  onCancel = () => {
    this.setState({
      visible: false,
      mainList: [],
      batchList: [],
    })
  }

  // 点击表格+号打开二级列表
  openMultiTable = async (expanded, record) => {
    if (expanded) {
      const { data, status, detail } = await getBatchDetail(record.id)
      if (status == 1) {
        // this.setState({
        //   batchList: data,
        // })
        record.record = data
        this.forceUpdate()
      } else {
        Message.error(detail)
      }
    }
  }

  // 销毁记录
  destroyData = async (record) => {
    const batchIds = []
    batchIds.push(record.id)
    const { data, status, detail } = await destroyRecord({
      batchIds: batchIds,
      description: this.state.description,
    })
    if (status == 1) {
      if (
        window.location.pathname == '/home/purchaseSalesInventory/ExpWarning'
      ) {
        this.getExpWarningList()
      }

      if (
        window.location.pathname == '/home/purchaseSalesInventory/StockWarning'
      ) {
        this.getStockWarningList()
      }
      Message.success('销毁成功')
      this.setState(
        {
          visible: false,
        },
        () => {
          this.setState({ description: '' })
        }
      )
    } else {
      Message.error(detail)
    }
  }

  // 输入销毁原因
  askDestroyReason = (record) => {
    this.setState({
      askingData: record,
      isAsking: true,
    })
  }

  onAskOk = () => {
    if (this.state.description) {
      this.destroyData(this.state.askingData)
      this.setState({ isAsking: false })
    } else {
      Message.error('请输入销毁原因')
    }
  }

  onAskCancel = () => {
    this.setState({
      isAsking: false,
      askingData: {},
      description: '',
    })
  }

  render() {
    const { dataSource, visible, mainList } = this.state
    // 主界面列表
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
      },
      {
        title: '商品图片',
        dataIndex: 'photoUrl',
        render: (text, record, index) => {
          return (
            <a
              href={fixPhotoUrl(text)}
              target="_blank"
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              <img className="product_pic" src={fixPhotoUrl(text)} />
            </a>
          )
        },
      },
      {
        title: '商品名称',
        dataIndex: 'name',
      },
      {
        title: '库存总量',
        dataIndex: 'quantity',
      },
    ]

    // 二级列表父列表
    const mainColumns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '批次号',
        dataIndex: 'batchNumber',
        key: 'batchNumber',
      },
      {
        title: '库存数',
        dataIndex: 'quantity',
        key: 'quantity',
      },
      {
        title: '入货时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record, index) => {
          return <div>{toNormalTime(text)}</div>
        },
      },
      {
        title: '过期时间',
        dataIndex: 'expirationDate',
        key: 'expirationDate',
        render: (text, record, index) => {
          if (text == '1970-01-01') {
            return '无'
          } else {
            return text
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'handle',
        key: 'handle',
        render: (text, record, index) => {
          // <Popconfirm
          //   title="确认要销毁此批次记录？"
          //   onConfirm={() => {
          //     this.destroyData(record)
          //   }}
          //   okText="是"
          //   cancelText="否"
          // >
          //   <a>销毁</a>
          // </Popconfirm>
          if (record.state == 1) {
            return '已销毁'
          } else {
            return (
              <a
                onClick={() => {
                  this.askDestroyReason(record)
                }}
              >
                销毁
              </a>
            )
          }
        },
      },
    ]

    const expandedRowRender = (record, index, indent, expanded) => {
      // 二级列表子列表
      const batchColumns = [
        {
          title: 'id',
          dataIndex: ['store', 'id'],
          key: 'id',
        },
        {
          title: '所在仓库',
          dataIndex: ['store', 'name'],
          key: 'name',
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
        },
      ]

      return (
        // 二级列表子列表组件
        <MultiTable
          batchColumns={batchColumns}
          record={record}
          batchList={record.record}
          openMultiTable={this.openMultiTable}
          tableStatus="records"
          ref={this.multiTableRef}
        ></MultiTable>
      )
    }

    return (
      <div>
        <Table
          rowKey={(record, index) => index}
          bordered
          columns={columns}
          dataSource={dataSource}
          className="mt-20"
          onRow={(record, index) => {
            return {
              onClick: () => {
                this.openModal(record)
              },
            }
          }}
        ></Table>

        <Modal
          visible={visible}
          title="批次记录"
          onOk={this.onOk}
          onCancel={this.onCancel}
          width="800px"
          destroyOnClose={true}
        >
          <div>
            <Table
              style={{ marginTop: '30px' }}
              bordered
              columns={mainColumns}
              expandable={{
                expandedRowRender,
                defaultExpandedRowKeys:
                  mainList && mainList.length == 1 ? mainList[0].id : null,
                onExpand: (expanded, record) => {
                  this.openMultiTable(expanded, record)
                },
                rowExpandable: (record) => {
                  if (record.state == 1) {
                    return false
                  } else {
                    return true
                  }
                },
              }}
              dataSource={mainList}
              size="small"
              rowKey={(record, index) => index}
            />
          </div>
        </Modal>

        <Modal
          visible={this.state.isAsking}
          title="销毁原因"
          onOk={this.onAskOk}
          onCancel={this.onAskCancel}
          zIndex="1999"
        >
          <Input
            placeholder="请输入销毁原因"
            value={this.state.description}
            onChange={(e) => this.setState({ description: e.target.value })}
          />
        </Modal>
      </div>
    )
  }
}
export default withRouter(Statement)



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/ExpAndStockWarning/index.js